package com.wintermar.inspection.core.ui.component.button.variant

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.LocalAppTheme

sealed class ButtonPaletteVariant {
    @Composable
    abstract fun palette(): ButtonPaletteStateModel

    @Composable
    protected fun disabledPalette(): ButtonPaletteModel {
        val color = LocalAppTheme.current.color
        return ButtonPaletteModel(
            backgroundColor = color.surface.brand.primary.disabled,
            textColor = color.text.disabled,
            iconColor = color.icon.disabled,
        )
    }

    object Primary : ButtonPaletteVariant() {
        @Composable
        override fun palette(): ButtonPaletteStateModel {
            val color = LocalAppTheme.current.color
            return ButtonPaletteStateModel(
                default = ButtonPaletteModel(
                    backgroundColor = color.surface.brand.primary.default,
                    textColor = color.text.onBrand,
                    iconColor = color.icon.onBrand,
                ),
                disabled = disabledPalette()
            )
        }
    }

    object Secondary : ButtonPaletteVariant() {
        @Composable
        override fun palette(): ButtonPaletteStateModel {
            val color = LocalAppTheme.current.color
            return ButtonPaletteStateModel(
                default = ButtonPaletteModel(
                    backgroundColor = color.surface.brand.primarySubtle.default,
                    textColor = color.text.brand,
                    iconColor = color.icon.brand,
                ),
                disabled = disabledPalette()
            )
        }
    }

    object Outline : ButtonPaletteVariant() {
        @Composable
        override fun palette(): ButtonPaletteStateModel {
            val color = LocalAppTheme.current.color
            return ButtonPaletteStateModel(
                default = ButtonPaletteModel(
                    backgroundColor = color.bg.normal,
                    textColor = color.text.brand,
                    iconColor = color.icon.brand,
                    borderColor = color.border.default
                ),
                disabled = disabledPalette().copy(
                    borderColor = color.border.default
                )
            )
        }
    }

    object Ghost : ButtonPaletteVariant() {
        @Composable
        override fun palette(): ButtonPaletteStateModel {
            val color = LocalAppTheme.current.color
            return ButtonPaletteStateModel(
                default = ButtonPaletteModel(
                    backgroundColor = Color.Transparent,
                    textColor = color.text.brand,
                    iconColor = color.icon.brand,
                ),
                disabled = disabledPalette().copy(
                    backgroundColor = color.bg.normal
                )
            )
        }
    }

    object Danger : ButtonPaletteVariant() {
        @Composable
        override fun palette(): ButtonPaletteStateModel {
            val color = LocalAppTheme.current.color
            return ButtonPaletteStateModel(
                default = ButtonPaletteModel(
                    backgroundColor = color.surface.semantic.error.bold.default,
                    textColor = color.text.onBrand,
                    iconColor = color.icon.onBrand,
                ),
                disabled = disabledPalette()
            )
        }
    }
}
